<route>
{
name: "index",
meta: {
layout: "Default"
}
}
</route>

<template>
  <HelloWorld />
</template>

<script lang="ts" setup>
  // asdaasd
</script>
